import { useState, useCallback, useEffect } from "react";
import { request } from "../../httpClient";

export const useVehicleMarkList = () => {
  const [vehicleMarkListLoading, setVehicleMarkListLoading] = useState(false);
  const [vehicleMarkList, setVehicleMarkList] = useState([]);

  const getVehicleMarkList = useCallback(async (vehicle_id) => {
    setVehicleMarkListLoading(true);
    const res = await request({
      path: `vehicle-tariff/list?vehicle_id=${vehicle_id}`,
    });
    setVehicleMarkList(res?.data);
    setVehicleMarkListLoading(false);
    return res?.data;
  }, []);

  return { vehicleMarkListLoading, vehicleMarkList, getVehicleMarkList };
};
